export const ITEM_DETAILS_ACTION = 'ITEM_DETAILS_ACTION';
export const ITEM_DETAILS_SUCCESS_ACTION = 'ITEM_DETAILS_SUCCESS_ACTION';
export const ITEM_DETAILS_FAILURE_ACTION = 'ITEM_DETAILS_FAILURE_ACTION';
